module.exports = __webpack_public_path__ + "static/media/TRI-SEAL.e3bbb01e.jpg";